class Rates {
  constructor(ratesContainer) {
    this.ratesContainer = document.querySelector(ratesContainer);
    if (this.ratesContainer) {
      this.starsContainer = this.ratesContainer.querySelector('span');
    }
  }

  activeRate() {
    if (this.ratesContainer) {
      this.starsContainer.addEventListener('click', (e) => {

        let currentClickedItem = e.target;

        this.resetRates();

        let elementSiblings = ratesTools.getSiblingRates(currentClickedItem, 'active');

        ratesTools.setActiveRates(currentClickedItem, elementSiblings);
      });
    }
  }

  resetRates() {
    if (this.ratesContainer) {
      const starsElement = this.starsContainer.querySelectorAll('a');

      starsElement.forEach(starItem => {

        if (starItem.classList.contains('selected-rating')) {

          starItem.classList.remove('selected-rating')
        }
      });
    }
  }
}

const ratesTools = {

  getSiblingRates(currentElement, selector) {
    let siblings = [];

    currentElement = currentElement.previousElementSibling;

    while (currentElement) {
      if (currentElement.matches(selector)) break;

      siblings.push(currentElement);

      currentElement = currentElement.previousElementSibling;
    }
    return siblings;
  },

  setActiveRates(currentElement, currentElementSiblings) {
    currentElement.classList.add('selected-rating');

    currentElementSiblings.forEach(currentElementSiblingsItem => {

      currentElementSiblingsItem.classList.add('selected-rating');

    })
  },
};

export default Rates;


// WEBPACK FOOTER //
// ./scripts/modules/rates.js